import { supabase } from '../supabaseClient';

// Award milestones (Otto wardrobe addendum §4). Every brief award fires
// the Captain-Otto celebration; a MILESTONE award additionally shows a
// milestone label/flourish. Counted PER STAFF MEMBER — each Fusion user
// has their own running total of briefs THEY awarded (not per-org).
//
// Milestone numbers: {1, 5, 10, 25, 50, 75} then STRICTLY every 50 from
// 100 (100, 150, 200, 250 …). After 100 it is every 50 exactly — 125,
// 175, 225 do NOT trigger.
const FIXED_MILESTONES = new Set([1, 5, 10, 25, 50, 75]);

export function isAwardMilestone(count) {
  if (!Number.isInteger(count) || count < 1) return false;
  if (FIXED_MILESTONES.has(count)) return true;
  return count >= 100 && count % 50 === 0;
}

// Ordinal-suffixed milestone label, e.g. "Your 50th brief awarded!".
function ordinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
}

export function milestoneLabel(count) {
  return `Your ${ordinal(count)} brief awarded!`;
}

// Count the briefs a given staff member has awarded — briefs they closed
// with a winner selected. This is the user's running personal total; the
// award being celebrated is included (call AFTER the award is persisted).
export async function countAwardsByUser(userId) {
  if (!userId) return 0;
  const { count } = await supabase
    .from('briefs')
    .select('*', { count: 'exact', head: true })
    .eq('closed_by', userId)
    .not('awarded_supplier_id', 'is', null);
  return count || 0;
}
